import { Anchor, Stack } from '@mantine/core';
import { useNavigate } from '@repo/common/hooks/useNavigate';
import { Button, Text, Title } from '@repo/foundations';

export function FreeTrialEndingContent() {
	const navigate = useNavigate();

	const handleBookDemo = () => {
		window.open(
			'https://secoda.co/contact-sales',
			'_blank',
			'noopener,noreferrer'
		);
	};

	const handleNavigateToPricing = () => {
		navigate('/plans');
	};

	return (
		<Stack spacing="lg">
			<Title order={1}>Free trial expires tomorrow</Title>
			<Text>
				This is an important reminder that your free trial of Secoda is set to
				expire in just 24 hours. To continue experiencing the full spectrum of
				Secoda's advanced features and benefits without interruption, we
				strongly recommend upgrading your subscription plan today.
			</Text>
			<Text>
				If you have any questions,{' '}
				<Anchor onClick={handleBookDemo}>book a demo with us.</Anchor>
			</Text>
			<Button w="fit-content" onClick={handleNavigateToPricing}>
				Choose your plan
			</Button>
		</Stack>
	);
}
